export enum QuickStartStep {
  CreateAccount = 'createdAccount',
  Account = 'account',
  Invoice = 'invoice',
  Purchases = 'purchases',
  EInvoicing = 'eInvoicing',
  Bank = 'bank',
}
